// data/languages/swahili/categories/couleurs.ts

import { CategoryData } from '../../../../types/types';

export const couleurs: CategoryData = {
  'Nyeupe': { translation: 'Blanc', translationEn: 'White', illustration: '⚪', audio: 'Sw-nyeupe' },
  'Nyeusi': { translation: 'Noir', translationEn: 'Black', illustration: '⚫', audio: 'Sw-nyeusi' },
  'Nyekundu': { translation: 'Rouge', translationEn: 'Red', illustration: '🔴', audio: 'Sw-nyekundu' },
  'Buluu': { translation: 'Bleu', translationEn: 'Blue', illustration: '🔵', audio: 'Sw-buluu' },
  'Kijani isiokoza': { translation: 'Vert', translationEn: 'Green', illustration: '🟢', audio: 'Sw-kijani_isiokoza' },
  'Manjano': { translation: 'Jaune', translationEn: 'Yellow', illustration: '🟡', audio: 'Sw-manjano' },
  'Kijivujivu': { translation: 'Gris', translationEn: 'Gray', illustration: '⚪', audio: 'Sw-kijivujivu' },
  'Damu ya mzee': { translation: 'Marron', translationEn: 'Brown', illustration: '🟤', audio: 'Sw-Damu_ya_mzee' },
   'Rangi ya udongo': { translation: 'Marron', translationEn: 'Brown', illustration: '🟤', audio: 'Sw-Rangi_ya_udongo' },
   'Rangi ya mazima': { translation: 'Crème', translationEn: 'Cream', illustration: '', audio: 'Sw-Rangi_ya_mazima' },
  'Rangi ya chungwa': { translation: 'Orange', translationEn: 'Orange', illustration: '🟠' },
  'Zambarau iliokoza': { translation: 'Violet', translationEn: 'Purple', illustration: '🟣', audio: 'Sw-zambarau_iliokoza' },
  'Waridi': { translation: 'Rose', translationEn: 'Pink', illustration: '🌸', audio: 'Sw-waridi' },
  'Kijani iliokoza': { translation: 'Vert foncé', translationEn: 'Dark Green', illustration: '🟢', audio: 'Sw-kijani_iliokoza' },
   
 
};

export default couleurs;

export {};
